import React from 'react';
import { makeStyles } from '@mui/styles';
import { useFullScreen } from 'state/providers/FullScreenProvider';
import { translate } from 'translations/translator';
import selectorBackground from 'assets/images/counter.png';
import fullscreenIcon from 'assets/images/icons/fullscreen.png';
import { remCalc } from 'util/style-util';

const t = (key, options?) => translate('common', key, options);

const FullScreenButton = () => {
  const classes = useStyles();
  const [{ screen1Handle }, { setFullScreen }] = useFullScreen();

  const handleFullScreenCick = () => {
    setFullScreen(true);
    screen1Handle.enter();
  };
  return (
    <div id="fullScreenButton" onClick={handleFullScreenCick} className={classes.button}>
      <img src={fullscreenIcon} className={classes.iconImage} alt={t('present')} />
      <span className={classes.text}>{t('present')}</span>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  text: {
    color: 'black',
    marginLeft: '-10px'
  },
  iconImage: {
    height: remCalc(20)
  },
  button: {
    cursor: 'pointer',
    width: '165px',
    height: remCalc(48),
    backgroundColor: 'transparent',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${selectorBackground})`,
    paddingTop: remCalc(5),
    marginRight: remCalc(20),
    textAlign: 'center',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    display: 'flex',
    '&:hover': {
      transform: 'scale(1.05, 1.05)'
    }
  }
}));

export default FullScreenButton;
